import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, Result } from 'antd';
import { LockOutlined, CheckCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async ({ password }) => {
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      padding: 24,
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 400,
        width: '100%',
        boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
      }}>
        {done ? (
          <Result
            icon={<CheckCircleOutlined style={{ color: '#10b981', fontSize: 48 }} />}
            title="Password reset!"
            subTitle="Your password has been updated successfully."
            extra={
              <Button type="primary" onClick={() => navigate('/login')} style={{ borderRadius: 8 }}>
                Back to Login
              </Button>
            }
          />
        ) : (
          <>
            <div style={{ textAlign: 'center', marginBottom: 32 }}>
              <div style={{ width: 52, height: 52, background: 'linear-gradient(135deg,#0a40d9,#2e6bf5)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <LockOutlined style={{ color: '#fff', fontSize: 22 }} />
              </div>
              <Title level={3} style={{ margin: 0 }}>Set new password</Title>
              <Text style={{ color: '#6b7280' }}>Enter your new password below</Text>
            </div>

            {error && <Alert message={error} type="error" showIcon closable onClose={() => setError('')} style={{ marginBottom: 20, borderRadius: 10 }} />}
            {!token && <Alert message="Invalid or missing reset token." type="error" showIcon style={{ marginBottom: 20, borderRadius: 10 }} />}

            <Form layout="vertical" onFinish={handleSubmit} disabled={!token}>
              <Form.Item
                name="password"
                label="New Password"
                rules={[{ required: true, min: 8, message: 'At least 8 characters' }]}
              >
                <Input.Password placeholder="Min 8 characters" size="large" style={{ borderRadius: 10 }} />
              </Form.Item>
              <Form.Item
                name="confirm"
                label="Confirm Password"
                dependencies={['password']}
                rules={[
                  { required: true, message: 'Please confirm your password' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) return Promise.resolve();
                      return Promise.reject(new Error('Passwords do not match'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Repeat password" size="large" style={{ borderRadius: 10 }} />
              </Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block size="large" style={{ borderRadius: 10, fontWeight: 600 }}>
                Reset Password
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
